import React from 'react';
import { SuitDivider } from './SuitDivider';
import { SectionReveal } from './SectionReveal';
export function TheoremRoom() {
  return <section className="relative bg-felt felt-texture py-24 md:py-32" data-id="element-198">
      <div className="max-w-6xl mx-auto px-6" data-id="element-199">
        <SectionReveal data-id="element-200">
          {/* Section header */}
          <div className="text-center mb-16" data-id="element-201">
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl text-goldenrod uppercase tracking-[0.3em] mb-4" data-id="element-202">
              The Theorem Room
            </h2>
            <p className="font-body text-goldenrod/70 italic text-lg tracking-wide" data-id="element-203">
              The Regret Minimization Theorem
            </p>
            <SuitDivider className="mt-8 max-w-md mx-auto" data-id="element-204" />
          </div>

          {/* Theorem statements */}
          <div className="max-w-4xl mx-auto space-y-12 md:space-y-16" data-id="element-205">
            {/* Theorem I */}
            <div className="relative pl-20 md:pl-28" data-id="element-206">
              <div className="absolute left-0 top-0 font-display text-5xl md:text-7xl text-goldenrod/30 leading-none select-none" data-id="element-207">
                I
              </div>
              <div className="border-l-2 border-goldenrod/30 pl-8" data-id="element-208">
                <h3 className="font-display text-xl md:text-2xl text-ivory uppercase tracking-[0.15em] mb-4" data-id="element-209">
                  Adaptive Exploitation
                </h3>
                <p className="font-body text-ivory/85 text-lg md:text-xl leading-relaxed" data-id="element-210">
                  Our AI learns and exploits opponent tendencies in real-time.
                  Every hand played refines the model's understanding of
                  adversarial patterns, transforming observed behavior into
                  strategic advantage with each successive decision.
                </p>
              </div>
            </div>

            {/* Decorative separator */}
            <div className="flex justify-center text-goldenrod/30 tracking-[1em] text-sm select-none" aria-hidden="true" data-id="element-211">
              ◆ ◆ ◆
            </div>

            {/* Theorem II */}
            <div className="relative pl-20 md:pl-28" data-id="element-212">
              <div className="absolute left-0 top-0 font-display text-5xl md:text-7xl text-goldenrod/30 leading-none select-none" data-id="element-213">
                II
              </div>
              <div className="border-l-2 border-goldenrod/30 pl-8" data-id="element-214">
                <h3 className="font-display text-xl md:text-2xl text-ivory uppercase tracking-[0.15em] mb-4" data-id="element-215">
                  Complete Traversal
                </h3>
                <p className="font-body text-ivory/85 text-lg md:text-xl leading-relaxed" data-id="element-216">
                  Full game-tree traversal across all streets and decision
                  points. Our engines consider the complete topology of
                  strategic possibility — from preflop through river —
                  maintaining coherent strategy across the entire decision
                  horizon.
                </p>
              </div>
            </div>

            {/* Decorative separator */}
            <div className="flex justify-center text-goldenrod/30 tracking-[1em] text-sm select-none" aria-hidden="true" data-id="element-217">
              ◆ ◆ ◆
            </div>

            {/* Theorem III */}
            <div className="relative pl-20 md:pl-28" data-id="element-218">
              <div className="absolute left-0 top-0 font-display text-5xl md:text-7xl text-goldenrod/30 leading-none select-none" data-id="element-219">
                III
              </div>
              <div className="border-l-2 border-goldenrod/30 pl-8" data-id="element-220">
                <h3 className="font-display text-xl md:text-2xl text-ivory uppercase tracking-[0.15em] mb-4" data-id="element-221">
                  Equilibrium Convergence
                </h3>
                <p className="font-body text-ivory/85 text-lg md:text-xl leading-relaxed" data-id="element-222">
                  Counterfactual regret minimization that converges toward Nash
                  equilibrium. Through iterative self-play and regret
                  accumulation, our systems discover strategies that are
                  provably unexploitable — the mathematical foundation of
                  optimal play.
                </p>
              </div>
            </div>
          </div>
        </SectionReveal>
      </div>
    </section>;
}